import React from "react"
import { Link, PageProps, graphql } from "gatsby"

import Layout from "@/components/Layout"
import SEO from "@/components/SEO"
import Challenge from "@/components/Challenge"
import Countdown from "@/components/Countdown"
import { routes } from "@/utils/routes"
import Raised from "@/components/Pledge/Raised"

export const pageQuery = graphql`
  query RBAITogetherQuery {
    allSanityVideo(sort: {fields: position}) {
      edges {
        node {
          title
          position
          videoUrl
          description
          placeholder {
            asset {
              url
            }
          }
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`

const RBAITogether: React.FC<PageProps> = ({ data }: { data: any }) => {
  // TODO: console.log({ amountRaised: data.sanityPage.amountRaised })
  function getVideoLink(position: number) {
    if (position === 2) {
      return routes.schoolProjects()
    } else if (position === 3) {
      return routes.socialMobility()
    } else {
      return routes.video({ params: { slug: `video-${position}` } })
    }
  }

  return (
    <Layout
      sectionOne={
        <>
          <div className="relative h-[67vh] md:min-h-[75vh]">
            <video
              id="bgvid"
              className="absolute inset-0 w-full h-full object-cover -z-50 sm:hidden"
              playsInline
              autoPlay
              muted
              loop
            >
              <source src="https://rbai-foundation.s3-eu-west-1.amazonaws.com/videos/2025/rbai_giving_day_mobile.mp4" type="video/mp4" />
            </video>
            <video
              id="bgvid"
              className="absolute inset-0 w-full h-full object-cover -z-50 hidden sm:block"
              playsInline
              autoPlay
              muted
              loop
            >
              <source src="https://rbai-foundation.s3-eu-west-1.amazonaws.com/videos/2025/rbai_giving_day.mp4" type="video/mp4" />
            </video>
            <div className="absolute inset-0 bg-[#131312]/50 -z-40"></div>

            <div className="container text-white h-[67vh] md:min-h-[75vh] flex items-center px-4">
              <div className="pl-2 md:pl-6 lg:pl-10 max-w-[1000px] translate-y-10 md:translate-y-16 lg:translate-y-20">
                <div className="pb-4">
                  <h1
                    className="text-left text-white text-[300%] sm:text-[400%] md:text-[531.25%] leading-[1] font-bold normal-case tracking-normal font-gilroy"
                  >
                    RBAI Together 2023
                  </h1>
                  <div className="mt-5 h-[8px] sm:h-[10px] w-[200px] sm:w-[320px] bg-primary"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Gold four-option bar below the fold */}
        <div className="bg-primary w-full h-[33vh] md:h-auto md:block">
          <div className="flex flex-col h-full w-full md:grid md:grid-cols-4 md:gap-0 md:items-stretch md:min-h-[84px]">
              <a href={routes.socialMobility()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                Transformative Bursaries
              </a>
              <a href={routes.southWingDevelopment()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                The South Wing
              </a>
              <a href={routes.pledge()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                Sponsor a Paviour
              </a>
              <a href={routes.donate()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] text-[19px] leading-[32.3px] md:px-2">
                Donate
              </a>
            </div>
          </div>
        </>
      }
    >
      <SEO title="RBAI Together" />
      {/* <div>
        <div className="container pb-8">
          <div className="flex flex-col lg:flex-row lg:items-end gap-4 lg:gap-28 mt-12 px-4">
            <h2 className="leading-none text-4xl sm:text-7xl">
              OUR
              <br />
              <span className="text-primary">VISION</span>
            </h2>
            <p>
              Built on strong and historic principles, RBAI is constantly
              <br />
              evolving, and the School’s leadership have a clear vision for the
              future.
            </p>
          </div>
          <div className="px-4 mt-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <Feature
              title="Maximising"
              description="the academic potential of every pupil."
            />
            <Feature
              title="Promoting"
              description="pupil well-being – intellectually, emotionally, physically and socially."
            />
            <Feature
              title="Supporting"
              description="social mobility by providing the opportunity of a first class education to all."
            />
            <Feature
              title="Equipping"
              description="pupils for future employment opportunities, particularly in science, technology and the creative arts."
            />
            <Feature
              title="Inspiring"
              description="leaders and entrepreneurs, by providing a School environment where pupils can flourish through academic achievement, sport, and the"
            />
          </div>
        </div>
      </div> */}
      <Countdown />

      <div className="pt-8 lg:pt-16">
        <div className="container px-4 md:px-4 lg:px-6 xl:px-0">
          <div>
            <h2 className="leading-none text-3xl sm:text-5xl md:text-6xl font-gilroy font-bold normal-case">
              19/20 april 2023 - 36 hours when we came together to support <span className="text-primary">pupil bursaries</span>{" "} & <span className="text-primary">school projects</span>
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8 mt-16">
            {data.allSanityVideo.edges.map(({ node }: any) => (
              <Link to={getVideoLink(node.position)} key={node.position}>
                <Challenge
                  num={node.position}
                  image={node.placeholder?.asset?.url || "/images/placeholder.jpg"}
                  title={node.title}
                  description={node.description}
                  href={null}
                  wrapperClass="mb-3"
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default RBAITogether
